export default {
  hidden_rates:
    'Some payment methods also have their own rate, set by your platform support. Those apply instead of this rate.',
  title: 'Processing fees',
  subtitle: 'The processing fee {{company}} is charged on online payments, to cover Stripe’s fees.',
  card_title: 'Processing fee',
  status: {
    inherited_tag: 'Partner default',
    inherited: 'This restaurant is charged your default processing fee.',
    custom_tag: 'Custom',
    custom: 'This restaurant has its own processing fee, which replaces your default.',
    none_title: 'No processing fee is set',
    none: 'Neither this restaurant nor your default has a rate. Unless you confirmed a 0% margin on the partner processing-fee page, it can’t go live or take online payments; with that confirmation it is charged nothing and you pay Stripe’s fees on its payments.',
  },
  buttons: {
    set_custom: 'Set a custom fee',
    edit: 'Edit',
    cancel: 'Cancel',
    save: 'Save',
    reset_to_default: 'Reset to default',
  },
  toasts: {
    load_error: 'Could not load the processing fee.',
    failed_to_save_changes: 'Could not save the processing fee.',
    changes_got_saved: 'Processing fee saved',
    reset_to_default: 'This restaurant now uses your default processing fee.',
  },
};
